'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.endOfMonth;


// WEBPACK FOOTER //
// ./~/sugar-date/date/endOfMonth.js